/**
 * Created by xinjundong on 2017/11/22.
 */
var funcArr = []
let isActive = false;
export default function scrollEvent (func) {
  funcArr.push(func)
  if (!isActive) {
    isActive = true
    window.onscroll = function () {
      funcArr.forEach(function (func) {
        func()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/utils/scrollEvent.js